var fixA11Y;

fixA11Y = function() {
  var getContextualText;
  getContextualText = function($target) {
    var e;
    try {
      return $.trim($target.attr('title')) || $.trim($target.data('originalTitle')) || $.trim($target.closest('a').attr('title')) || $.trim($target.closest('a').text()) || $.trim($target.prev().children().length ? $($target.prev().children()[0]).text() : $target.prev().text()) || $.trim($target.next().children().length ? $($target.next().children()[0]).text() : $target.next().text()) || $.trim($target.parent().prev().children().length ? $($target.parent().prev().children()[0]).text() : $target.parent().prev().text()) || $.trim($target.parent().next().children().length ? $($target.parent().next().children()[0]).text() : $target.parent().next().text()) || ($.trim($target.attr('class')) ? $.trim($target.attr('class')).replace(/\s/g, ', ').replace(/[\-_]/g, ' ') : void 0) || ($target.attr('src') ? $target.attr('src').replace(/.*\/|\..*$/g, '') : void 0) || '';
    } catch (error) {
      e = error;
      console.error(e.message);
    }
  };
  $('img:not([alt])').each(function() {
    return $(this).attr('alt', '');
  });
  $('a').filter(function() {
    return $.trim($(this).text()) === '';
  }).each(function() {
    var span, text;
    text = getContextualText($(this)) || $.trim($.trim($(this).attr('href')) && $(this).attr('href').replace(/[\-_\/:]/g, ' ').replace(/^https*/g, ''));
    if (text) {
      span = document.createElement('span');
      span.className = 'sr-only';
      span.innerText = text;
      return this.appendChild(span);
    } else {
      return $(this).find('img:not([alt]), img[alt=""]').each(function() {
        var $this;
        $this = $(this);
        return $this.attr('alt', getContextualText($this));
      });
    }
  });
  return $('textarea:not([title]), textarea[title=""], input:not([title]), input[title=""], select:not([title]), select[title=""]').each(function() {
    var $this, text;
    $this = $(this);
    text = $.trim($this.attr('placeholder') || getContextualText($this));
    if (text) {
      return $this.attr('title', text);
    }
  });
};

$(function() {
  setTimeout(fixA11Y, 500);
  return $(document).ajaxSuccess(function() {
    return setTimeout(fixA11Y, 500);
  });
});

module.exports = fixA11Y;

